export const IDLE_WARNING = 'You have been inactive for too long. Please try to sign in again.';

export const TOKEN_EXPIRED_WARNING = 'Your access token has expired. Please try to sign in again.';
